export const content = `
    <div class="mb-1.5"> 此次增額保費資金來源若為貸款、保單借款或辦理公司及其他同業保單的終止契約(解約)時，您應充分了解以下相關權益及可能的風險。</div>
        <ul class="list-disc list-inside">
            <li class="indent-1.5 mb-1.5">
                此次補繳保費來源是以貸款或保單借款的金額再單筆追加投資型保單的保費，可能會因為這種循環財務槓桿操作方式而擴張個人信用，而且投資的淨值會隨著市場波動，當淨值跌的時候，可能會有損失，若無法償還您的貸款或借款本息時，可能會影響您的信用。
            </li>
            <li class="indent-1.5 mb-1.5">
                這張保單的帳戶價值可能因為費用收取、匯率波動或投資績效變動等因素，其帳戶價值可能造成損失或降低為零時，除了保單有停效或終止的風險外，未來領回的金額可能低於您所需償還的貸款或保單借款金額。
            </li>
            <li class="indent-1.5">
                若此次補繳保費來源是以公司或其他同業辦理的保單終止契約(解約)時，您清楚對您權益的影響，例如：解約金的損失、再購買新保單時因年齡增長而使保費提高、超過投保年齡上限或身體狀況影響導致可能無法投保、違反告知義務解除契約的除斥期間及健康險的等待期，都要重新計算等。
            </li>
        </ul>`;
